/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import tabFeature1 from "../images/illustration-features-tab-1.svg";
import tabFeature2 from "../images/illustration-features-tab-2.svg";
import tabFeature3 from "../images/illustration-features-tab-3.svg";

function Middle() {
    const [selectedTab, setSelectedTab] = useState(1);

    const handleTabClick = (index) => {
        setSelectedTab(index);
    };

    return (
        <div className="middle-area">
            <div className="features">
                <h4> Features</h4>
                <p>
                    Our aim is to make it quick and easy for you to access your favourite websites.
                    Your bookmarks sync between your devices so you can access them on the go.
                </p>
            </div>
            <div className="tabs">
                <div className="tab-titles">
                    <ul>
                        <li>
                            <a
                                href="#diagram"
                                className={selectedTab === 1 ? "active" : ""}
                                onClick={() => handleTabClick(1)}
                            >
                                Simple Bookmarking
                            </a>
                        </li>
                        <li>
                            <a
                                href="#diagram"
                                className={selectedTab === 2 ? "active" : ""}
                                onClick={() => handleTabClick(2)}
                            >
                                Speedy Searching
                            </a>            </li>
                        <li>
                            <a
                                href="#diagram"
                                className={selectedTab === 3 ? "active" : ""}
                                onClick={() => handleTabClick(3)}
                            >
                                Easy Sharing
                            </a>            </li>
                    </ul>
                </div>
                <div className="tab-area">
                    <div className="left">
                        {selectedTab === 1 && (
                            <img src={tabFeature1} alt="tab-1" className="tab-1" />
                        )}
                        {selectedTab === 2 && (
                            <img src={tabFeature2} alt="tab-2" className="tab-2" />
                        )}
                        {selectedTab === 3 && (
                            <img src={tabFeature3} alt="tab-3" className="tab-3" />
                        )}
                        <div className="diagram"></div>
                    </div>
                    <div className="info-area">
                        {selectedTab === 1 && (
                            <div>
                                <h4 className="tab-title">Bookmark in one click</h4>
                                <p className="tab-para">
                                    Organize your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favourite sites.
                                </p>
                            </div>
                        )}
                        {selectedTab === 2 && (
                            <div>
                                <h4 className="tab-title">Intelligent search</h4>
                                <p className="tab-para">
                                    Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks.
                                </p>
                            </div>
                        )}
                        {selectedTab === 3 && (
                            <div>
                                <h4 className="tab-title">Share your bookmarks</h4>
                                <p className="tab-para">
                                    Easily share your bookmarks and collections with others. Create a shareable link that you can send at the click of a button.
                                </p>
                            </div>
                        )}
                        <button className="chrome">More Info</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Middle;
